import React from 'react';

import AddIcon from '@mui/icons-material/Add';

import { useGridCreatorLevel } from '../../../../../../selectors/index.hooks';

import IconButtonWithTooltip from '../../../../../../../../components/IconButtonWithTooltip';

import { previewTypes } from '../../../../../../../../state/types';
import {
    activatePreview,
    resetLastMapClickPosition,
} from '../../../../../../../../state/_actions';

import TranslationHelper from '../../../../../../../../helpers/TranslationHelper';
import { useAppDispatch } from '../../../../../../../../hooks';
import { useGridSourceSet } from '../../../../../../selectors/composed/index.hooks';

interface IOwnProps {
    isGridFullscreen: boolean;
}

const AddButton = ({ isGridFullscreen }: IOwnProps) => {
    const dispatch = useAppDispatch();

    const sourceSet = useGridSourceSet();

    const creatorLevel = useGridCreatorLevel();

    const openCreatePane = () => {
        if (sourceSet) {
            dispatch(resetLastMapClickPosition());

            dispatch(
                activatePreview(
                    sourceSet.id,
                    '',
                    previewTypes[sourceSet.id],
                    'add',
                    {
                        type: 'preview',
                        level: creatorLevel + 1,
                    },
                    undefined,
                    false,
                    false
                )
            );
        }
    };

    const addAction = sourceSet?._meta?.actions?.add;

    if (!isGridFullscreen && addAction) {
        return (
            <IconButtonWithTooltip
                title={TranslationHelper.translate('Add')}
                onClick={openCreatePane}
            >
                <AddIcon />
            </IconButtonWithTooltip>
        );
    }
    return null;
};

export default AddButton;
